<template>
  <div>
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="12">
            <div class="bg-purple">
              <img
                class="bg-purpleimg"
                src="../assets/slices/logo.png"
                alt=""
              />
            </div>
          </el-col>
          <el-col :span="12">
            <el-menu
              router
              :default-active="$route.path"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              active-text-color="#0094DC"
            >
              <el-menu-item index="/home/index">首页</el-menu-item>
              <el-submenu index="3">
                <template slot="title">产品与服务</template>
                <el-menu-item index="/home/product">产品</el-menu-item>
                <el-menu-item index="/home/serve">服务</el-menu-item>
                <el-menu-item @click="openDocsApi('/docsApi')"
                  >文档</el-menu-item
                >
              </el-submenu>
              <el-menu-item index="/home/liberalpay">解决方案</el-menu-item>
              <el-menu-item index="/home/contactUs">联系我们</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-header>
      <el-main :class="isPhone ? 'el-main2' : 'el-main'">
        <router-view />
      </el-main>
      <el-footer :class="isPhone ? 'el-footer2' : 'el-footer'">
        <bottom />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import bottom from "../module/bottom";
export default {
  components: {
    bottom,
  },
  data() {
    return {
      screenWidth: document.documentElement.clientWidth,
      isPhone: document.documentElement.clientWidth < 993,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = document.body.offsetWidth;
      this.isPhone = document.body.offsetWidth < 993;
    });
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },

    openDocsApi(url) {
      // console.log("获取当前页面url：", window.location.href);

      // 在新窗口中打开文档页面
      window.open("#" + url, "_blank");

      // window.open(url, "_Parent"); // 在新窗口中打开文档页面
    },
  },
};
</script>

<style lang="less" scoped>
.el-container {
  margin: auto;
}

.el-header {
  padding: 0;
  height: 8.8rem;
  position: fixed;
  width: 100vw;
  background: #fff;
  z-index: 1000;
  box-shadow: 0px 10px 4px -5px rgb(200 200 200);
  .el-row {
    width: 156rem;
    margin: auto;
    .bg-purple {
      display: flex;
      .bg-purpleimg {
        display: block;
        width: 12rem;
        height: 6rem;
        padding: 0 0 0 26rem;
      }
    }
    .el-menu-demo {
      position: relative;
    }
    .el-menu {
      background: none;
      .el-menu--horizontal {
        border-bottom: 0 !important;
      }
    }
    .el-menu.el-menu--horizontal {
      border-bottom: none !important;
    }
  }
}
.el-main {
  padding: 0;
  // margin-bottom: 10rem
  // width: 108rem;
  // margin: auto;
}
.el-main2 {
  padding: 0;
  margin-bottom: 10rem;
  width: 156rem;
  // margin: auto;
}
.el-footer {
  padding: 0;
  // width: 108rem;
  // margin: auto;
  // margin-top: 10rem;
}
.el-footer2 {
  padding: 0;
  width: 156rem;
  // margin: auto;
  margin-top: 10rem;
}

.el-dropdown-menu__item,
.el-menu-item {
  font-size: 1.6rem;
  font-weight: 500;
}

/deep/.el-submenu__title {
  font-size: 1.6rem;
  font-weight: 500;
}
</style>
